import { createContext } from 'react';

const CollectionsScreenContext = createContext( null );

export default CollectionsScreenContext;